module.exports = __webpack_public_path__ + "img/v1.2.2689d410.png";